<template>
<v-layout class="container-notification" >
    <v-flex xs12 sm6 offset-sm3>
      <v-card class="scroll height-res">
        <v-toolbar color="#211850" dark>
          <v-toolbar-title>Mis Avisos</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn v-on:click="closeNotifications" icon >
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-list two-line>
           <v-list-tile
            v-for="(notification) in getNotifications" :key="notification.id"
            @click="updateNotificationView(notification)"
          >
            <v-list-tile-content>
              <v-list-tile-title><b>{{ notification.title }}</b></v-list-tile-title>
              <v-list-tile-sub-title>{{ notification.content }}</v-list-tile-sub-title>
            </v-list-tile-content>

            <IconNotification :seen_at="notification.seen_at" :key="notification.id" ></IconNotification>

          </v-list-tile>
          <infinite-loading @infinite="infiniteHandler">
            <div slot="spinner">Cargando...</div>
            <div slot="no-more" style="visibility: hidden">No hay más resultados</div>
            <v-layout slot="no-results">
              <v-flex sm12>
                <v-card height="400px">
                  <v-layout align-center justify-center row wrap fill-height>
                    <v-flex
                      sm12
                      class="text-29-security text-md-center font-weight-bold"
                      style="color: #525252"
                    >No hay más notificaciones </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </infinite-loading>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters, mapMutations } from "vuex";
import IconNotification from "@/components/Notifications/IconNotification";

  export default {
    components: {
      IconNotification,
    },
    data () {
      return {
        selectedItem: 1,
        page: 2,
      }
    },
    methods: {
      ...mapActions("notifications", ["updateUserNotification"]),
      ...mapMutations("notifications", ["updateNotification", "setNotifications"]),

      updateNotificationView(notification){
        this.$forceUpdate();
        if(notification.seen_at == null){
          this.updateUserNotification(notification.id)
          this.updateNotification(notification.id)
        }
        if (notification.external_notification == false){
          this.$router.push({ path: notification.link, replace: true }).catch(()=>{});
        }else {
         window.open(notification.link)
        }
      },
      infiniteHandler($state) {
        setTimeout(() => {
          let api = `${process.env.VUE_APP_API_URL}/notifications`;
          axios.get(api, { params: { page: this.page, view_as: localStorage.getItem("view_as")} }).then(({ data }) => {
            if (data.notifications.length) {
              this.page += 1;
              this.setNotifications(data.notifications)
              $state.loaded();
            } else {
              $state.complete();
            }
          });
        }, 1000);
      },
      closeNotifications() {
        this.$emit('isClosed');
      },
    },
    computed: {
      ...mapGetters("notifications", ["getNotifications"]),
  },
  }
</script>

<style>
.container-notification{
  width: 820px;

}
.height-res{
   /* height: 478px; */
   height: 50vh;
}
.icon-m{
  margin-right: 10px;
}
.scroll {
   overflow-y: scroll;
   height: "400px";
}
@media screen and (min-width: 320px) and (max-width: 599px) {
  .container-notification{
    width: 300px;
    margin-left: 385px;
  }
}
</style>

